export default "__VITE_PUBLIC_ASSET__b1f15536__"